module.exports = __webpack_public_path__ + "img/building_qr.ef83c080.gif";